import { macoAxios } from '@/axios'
import { ToastError } from '@/utils'

export const researchSelection = (method, fisPersid, resourceType, resourceId) => {
  return new Promise((resolve, reject) => {
    // map 'resourceType' from FOB to types from MACO
    let macoActivity = {
      forschungsprojekt: 'projects',
      kooperation: 'cooperations',
      publikation: 'publications',
      veranstaltung: 'events',
      preis: 'awards'
    }
    // convert number as string to number from type Number
    let id = Number(resourceId)
    // set a payload in axios differs between http methods
    let payload = {}
    if (method && ['get', 'post', 'put', 'patch'].includes(method) && !Number.isNaN(id)) {
      payload = { id }
    } else if (method && method === 'delete' && !Number.isNaN(id)) {
      payload = { data: { id } }
    }
    // only fetch research selection if fisPersid is given
    if (fisPersid) {
      // set endpoint url for http method (default: fetch all)
      let endpoint = `/research_selection/${fisPersid}`
      if (method && ['post', 'delete'].includes(method) && macoActivity[resourceType]) {
        endpoint += `/${macoActivity[resourceType]}`
      }
      // fetch research selection
      macoAxios(method, endpoint, payload)
      .then((response) => {
        let data = {}
        Object.entries(macoActivity).forEach(([fobActivityName, macoActivityName]) => {
          data[fobActivityName] = response.data[macoActivityName]
        })
        resolve(data)
      })
      .catch((error) => {
        // identify error from maco, 403: max favourites reached
        if (error.response.status === 403 &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.research_selection
        ) {
          reject('AboutMe.toast.researchSelectionLimit')
        } else {
          // default error handling
          ToastError(error, 5000, {
            method,
            fisPersid,
            resourceId,
            resourceType,
            macoActivity: macoActivity[resourceType]
          })
        }
        reject(error)
      })
    } else {
      ToastError('Could not favour research activitiy', 5000, {
        method,
        fisPersid,
        resourceId,
        resourceType,
        macoActivity: macoActivity[resourceType]
      })
      reject()
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/maco.js